<template>
  <div id="app">
    <router-view />
    <notifications />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
</style>
